const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      background:
        'linear-gradient(286.02deg, #080A14 38.02%, #10121E 61.92%, #282A34 74.32%, #404354 90.71%, #343643 99.65%)',
      color: '#FFFFFF',
      position: 'relative',
      overflow: 'hidden',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    backgroundPattern: {
      position: 'absolute',
      inset: '0',
      opacity: '0.1',
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    },
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '0 20px',
      position: 'relative',
      zIndex: '1'
    },
    title: {
      fontWeight: '700',
      fontSize: '40px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '24px',
      color: '#FFFFFF',
      '@media (max-width: 768px)': {
        fontSize: '30px'
      }
    },
    subtitle: {
      fontSize: '20px',
      textAlign: 'center',
      marginBottom: '40px',
      color: 'rgba(255,255,255,0.9)',
      '@media (max-width: 768px)': {
        fontSize: '16px'
      }
    },
    buttonGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '16px',
      justifyContent: 'center',
      marginTop: '16px'
    },
    themeBtn: {
      color: '#fff',
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: '500',
      padding: '16px 32px',
      textTransform: 'none',
      fontSize: '18px',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      borderRadius: '8px',
      border: 'none',
      transition: 'all 0.3s ease-in-out',
      boxShadow: '0 4px 15px rgba(150, 180, 220, 0.3)',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 25px rgba(150, 180, 220, 0.4)'
      },
      '@media (max-width: 768px)': {
        fontSize: '16px',
        padding: '12px 24px'
      }
    },
    outlineBtn: {
      color: '#FFFFFF',
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: '500',
      padding: '16px 32px',
      textTransform: 'none',
      fontSize: '18px',
      background: 'rgba(255,255,255,0.1)',
      border: '1px solid #FFFFFF',
      borderRadius: '8px',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        backgroundColor: '#FFFFFF',
        color: '#4f46e5'
      },
      '@media (max-width: 768px)': {
        fontSize: '16px',
        padding: '12px 24px'
      }
    }
  };
};

export default getStyles;
